export const columnNames = {
  AbsoluteTopImpressionRate: _TL_('Abs. top impr. rate'),
  AbsoluteTopImpressionShareLostToBudget: _TL_('Abs. top IS lost to budget'),
  AbsoluteTopImpressionShareLostToRank: _TL_('Abs. top IS lost to rank'),
  AbsoluteTopImpressionSharePercent: _TL_('Abs. top impr. share'),
  AdvertiserReportedRevenue: _TL_('Revenue'),
  AllConversionAdvertiserReportedRevenue: _TL_('All conv. revenue'),
  AllConversionCPA: _TL_('All conv. CPA'),
  AllConversionRate: _TL_('All conv. rate'),
  AllConversionRevenueOnAdSpend: _TL_('All conv. return on ad spend'),
  AllConversions: _TL_('All conv.'),
  AllConversionsCredit: _TL_('All conv.'),
  AllPartialConversionCPA: _TL_('All conv. CPA'),
  AllPartialConversionRate: _TL_('All conv. rate'),
  AuctionLostToAdQualityPercent: _TL_('IS lost to expected CTR'),
  AuctionLostToBidPercent: _TL_('IS lost to bid'),
  AuctionLostToBudgetPercent: _TL_('IS lost to budget'),
  AuctionLostToLandingPercent: _TL_('IS lost to ad relevance'),
  AuctionLostToRankPercent: _TL_('IS lost to rank'),
  AuctionWonPercent: _TL_('Impr. share (IS)'),
  AudienceImpressionShare: _TL_('Audience impr. share'),
  AudienceImpressionShareLostToBudget: _TL_('Audience is lost to budget'),
  AudienceImpressionShareLostToRank: _TL_('Audience is lost to rank'),
  AverageCPC: _TL_('Avg. CPC'),
  AverageCPM: _TL_('Avg. CPM'),
  AverageCPS: _TL_('Avg. CPS'),
  AverageCPV: _TL_('Avg. CPV'),
  AveragePosition: _TL_('Avg. pos.'),
  AverageWatchTimePerImpression: _TL_('Avg. watch time per impr.'),
  AverageWatchTimePerVideoView: _TL_('Avg. watch time per video view'),
  CPA: _TL_('CPA'),
  CTR: _TL_('CTR'),
  ClickAndPhoneSpend: _TL_('Total spend'),
  ClickSharePercent: _TL_('Click share'),
  Clicks: _TL_('Clicks'),
  CompletedVideoViews: _TL_('Completed video views'),
  ConversionRate: _TL_('Conv. rate'),
  Conversions: _TL_('Conv.'),
  ConversionsCredit: _TL_('Conv.'),
  CostPerDownload: _TL_('Cost per download'),
  CostPerFirstLaunch: _TL_('CPI'),
  CostPerPurchase: _TL_('Cost per purchase'),
  CostPerSubscription: _TL_('Cost per subscription'),
  Downloads: _TL_('Downloads'),
  EligibleImpressions: _TL_('Eligible impr.'),
  ExactMatchImpressionSharePercent: _TL_('Exact match impr. share'),
  FirstLaunches: _TL_('Installs'),
  ImpressionShare: _TL_('Impression share'),
  Impressions: _TL_('Impr.'),
  ManualCalls: _TL_('Manual calls'),
  MissedImpressions: _TL_('Missed impr.'),
  MissedImpressionsInsufficientBid: _TL_('Missed impr. insufficient bid'),
  MissedImpressionsNoBid: _TL_('Missed impr. no bid'),
  MissedImpressionsNoTax: _TL_('Missed impr. no tax'),
  MissedImpressionsOther: _TL_('Missed impr. other'),
  MissedImpressionsSpendingCapReached: _TL_('Missed impr. spending cap reached'),
  PTR: _TL_('PTR'),
  PartialConversionCPA: _TL_('CPA'),
  PartialConversionRate: _TL_('Conv. rate'),
  PhoneImpressions: _TL_('Phone impr.'),
  PostClickDownloadRate: _TL_('Post-click download rate'),
  PostClickFirstLaunchRate: _TL_('Post-click install rate'),
  PostInstallPurchaseRate: _TL_('Post-install purchase rate'),
  PostInstallSubscriptionRate: _TL_('Post-install subscription rate'),
  Purchases: _TL_('Purchases'),
  RelativeCTR: _TL_('Relative CTR'),
  ReturnOnAdSpend: _TL_('Return on ad spend'),
  RevenueOnAdSpend: _TL_('Return on ad spend'),
  SalesCount: _TL_('Sales Count'),
  Spend: _TL_('Spend'),
  Subscriptions: _TL_('Subscriptions'),
  TopImpressionRate: _TL_('Top impr. rate'),
  TopImpressionShareLostToBudget: _TL_('Top IS lost to budget'),
  TopImpressionShareLostToRank: _TL_('Top IS lost to rank'),
  TopImpressionSharePercent: _TL_('Top impr. share'),
  TotalWatchTimeInMS: _TL_('Total watch time'),
  VideoCompletionRate: _TL_('Video completion rate'),
  VideoViews: _TL_('Video views'),
  VideoViewsAt25Percent: _TL_('Video views at 25%'),
  VideoViewsAt50Percent: _TL_('Video views at 50%'),
  VideoViewsAt75Percent: _TL_('Video views at 75%'),
  ViewThroughConversions: _TL_('View-through conv.'),
  ViewThroughConversionsCPA: _TL_('View-through conv. CPA'),
  ViewThroughConversionsCredit: _TL_('View-through conv.'),
  ViewThroughConversionsRate: _TL_('View-through conv. rate'),
  ViewThroughConversionsReturnOnAdSpend: _TL_('View-through conv. return on ad spend'),
  ViewThroughConversionsRevenue: _TL_('View-through conv. revenue'),
  ViewThroughPartialConversionsCPA: _TL_('View-through conv. CPA'),
  ViewThroughPartialConversionsRate: _TL_('View-through conv. rate'),
  ViewThroughRate: _TL_('View through rate'),
  NetRevenue: _TL_('Net revenue'),
  WebsiteCoverage: _TL_('Website coverage'),
};

export const callTrackingStatusEnums = {
  NotApplicable: _TL_('Not applicable'),
  Eligible: _TL_('Eligible'),
  NotEligible: _TL_('Pending / ineligible'),
  ProvisioningPending: _TL_('Provisioning pending'),
  Provisioned: _TL_('Provisioned'),
};

export const bidStrategies = {
  InheritFromParent: _TL_('Inherit from parent'),
  MaxClicks: _TL_('Auto: Max Clicks'),
  MaxConversions: _TL_('Auto: Max Conversions'),
  TargetCpa: _TL_('Auto: Target CPA'),
  TargetRoas: _TL_('Auto: Target ROAS'),
  EnhancedCpc: _TL_('Enhanced CPC'),
  MaxConversionValue: _TL_('Auto: Maximize Conversion Value'),
  TargetImpressionShare: _TL_('Auto: Target Impression Share'),
  ManualCpa: _TL_('Manual CPA'),
  ManualCpc: _TL_('Manual CPC'),
  ManualCpv: _TL_('Manual CPV'),
  ManualCpm: _TL_('Manual CPM'),
  Commission: _TL_('Commission'),
  PercentCpc: _TL_('Percent CPC'),
  CostPerSale: _TL_('Auto: Cost Per Sale'),
  ViewableCpm: _TL_('CPM for maximizing reach'),
  Cpcv: _TL_('CPCV'),
};

export const bidStrategyTypes = {
  Commission: _TL_('Commission'),
  CostPerSale: _TL_('Auto: Cost Per Sale'),
  EnhancedCpc: _TL_('Enhanced CPC'),
  EnhancedCPC: _TL_('Enhanced CPC'),
  InheritFromParent: _TL_('Inherit from parent'),
  Manual: _TL_('Manual'),
  ManualCpa: _TL_('Manual CPA'),
  ManualCPA: _TL_('Manual CPA'),
  ManualCpc: _TL_('Manual CPC'),
  ManualCpi: _TL_('Manual CPI'),
  ManualCpm: _TL_('Manual CPM'),
  ManualCPM: _TL_('Manual CPM'),
  ManualCpv: _TL_('Manual CPV'),
  ManualCPV: _TL_('Manual CPV'),
  MaxClicks: _TL_('Auto: Max Clicks'),
  MaxConversions: _TL_('Auto: Max Conversions'),
  MaxConversionValue: _TL_('Auto: Maximize Conversion Value'),
  MaxImpressions: _TL_('Auto: Maximize Impressions'),
  MaxReach: _TL_('Auto: Maximize Reach'),
  MaxRoas: _TL_('Auto: Maximize ROAS'),
  MaximizeClicks: _TL_('Auto: Max Clicks'),
  MaximizeConversions: _TL_('Auto: Max Conversions'),
  PercentCpc: _TL_('Percent CPC'),
  TargetCpa: _TL_('Auto: Target CPA'),
  TargetCPA: _TL_('Auto: Target CPA'),
  TargetImpressionShare: _TL_('Auto: Target Impression Share'),
  TargetRoas: _TL_('Auto: Target ROAS'),
  UsePortfolioBidStrategyType: _TL_('Use portfolio bid strategy type'),
};
